module.exports = __webpack_public_path__ + "static/img/inca_200x75.af33b11e.png";